import React from 'react'
import "./Card.css";
import { useContext } from 'react';
import { theamContex } from '../../Context';

function Card(props) {
  // console.log(props);
  const theme = useContext(theamContex);
  const darkMode = theme.state.darkMode;
  return (
    <div className="card"
    style={
      {
        background: darkMode?'black':'',
        color: darkMode?'white':'',
      }
    }
    >
        <div className="overlay">
          <h1>{props.emoji}</h1>
          <span>{props.heading}</span>
          <p>{props.bar}</p>
          <p>{props.skill}</p>
          <div id="bar" style={{color:'white'}} className= {props.class}>-</div>
        </div>
    </div>
  )
}

export default Card;